import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classNames from 'classnames';
import styles from './fieldset.module.scss';
import { useFocus } from '../../hooks/use-focus';
export const Fieldset = _ref => {
  let {
    id,
    ariaLabelledBy,
    ariaDescribedBy,
    required,
    className,
    onBlur,
    onFocus,
    ...rest
  } = _ref;
  const {
    handleFocus,
    handleBlur,
    containerRef
  } = useFocus({
    onBlur,
    onFocus
  });
  const labelledBy = [ariaLabelledBy, ariaDescribedBy].filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("fieldset", _extends({
    ref: containerRef,
    id: id,
    "aria-labelledby": labelledBy,
    "aria-required": required,
    className: classNames(styles.fieldset, className),
    onBlur: handleBlur,
    onFocus: handleFocus
  }, rest));
};
//# sourceMappingURL=fieldset.js.map